import { IconTitleDescriptionItemType } from '@application/Types/ComponentTypes'

const size = 3

export const getGroupedItems = (items: IconTitleDescriptionItemType[]): IconTitleDescriptionItemType[][] =>
    items.reduce((acc: IconTitleDescriptionItemType[][], _curr, i) => {
        if (!(i % size)) {
            acc.push(items.slice(i, i + size))
        }
        return acc
    }, [])
